import { TransitionType } from 'types/Transitions';

export const transitionNames: { [x in TransitionType]: string } = {
  [TransitionType.None]: 'None',
  [TransitionType.Fade]: 'Fade',
  [TransitionType.WipeDiagonal]: 'Wipe',
  [TransitionType.Shape]: 'Shape'
};
